
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import TextArea from "components/forms/TextArea";
import ToggleSwitch from "components/actions/ToggleSwitch";
import SectionWrapper from "components/wrappers/SectionWrapper";
import { BiPlus } from 'react-icons/bi'
import Language from "components/Language";
import PropTypes from 'prop-types';

const CreateAnnouncement = (props) => {

    const { t } = useTranslation();

    const { register, handleSubmit, formState: { errors, isValid } } = useForm({ mode: 'onChange' });

    const [isOpen, setIsOpen] = useState(false);

    const [isEnabled, setIsEnabled] = useState()

    const onSubmit = (data) => {

        if (data) {
            props.onCreate(
                {
                    ...data,
                    enabled: isEnabled
                }
            )
            setIsOpen(false)
        }

    }

    useEffect(() => {

    }, [isOpen])


    return (
        <>
            <button
                className={`flex shadow first-letter:capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${props?.disabled ? 'bg-gray-200 text-gray-400' : 'bg-gray-100  focus:ring-gray-200 hover:text-white hover:bg-gray-700'}`}
                onClick={() => setIsOpen(true)}>
                <BiPlus /> <span className="mx-2 text-sm font-medium capitalize">{t('actions.create')} </span>
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('actions.create')}
            >

                <SectionWrapper
                // title={t('form.message')}
                >

                    <div className="pb-8 flex justify-between font-bold ">
                        Status <ToggleSwitch isEnabled={setIsEnabled} />
                    </div>


                    <form className="w-[480px] " onSubmit={handleSubmit(onSubmit)}>
                        <div className="capitalize font-bold">
                            {t('form.message')}
                        </div>
                        <TextArea
                            id="arabic"
                            label={<Language _key="ar" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("arabic", {
                                required: t('form.error_announcement_msg'), maxLength: { value: 100, message: t('form.error_announcement_msg') }
                            })}
                            error={errors.arabic}
                        />

                        {/* <TextArea
                            id="arabic_dialect_ma"
                            label={<Language _key="arabic_dialect_ma" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("arabic_dialect_ma", {
                                required: t('form.error_announcement_msg'), maxLength: 100
                            })}
                            error={errors.arabic_dialect_ma}
                        /> */}


                        <TextArea
                            id="french"
                            label={<Language _key="fr" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("french", {
                                required: t('form.error_announcement_msg'), maxLength: { value: 100, message: t('form.error_announcement_msg') }
                            })}
                            error={errors.french}
                        />
                        <TextArea
                            id="english"
                            label={<Language _key="en" showKeyOnly />}
                            placeholder={t('actions.enter') + " " + t('form.message')}
                            register={register("english", {
                                required: t('form.error_announcement_msg'), maxLength: { value: 100, message: t('form.error_announcement_msg') }
                            })}
                            error={errors.english}
                        />

                        <div className="justify-end flex items-center mt-8">
                            <input type='button' value={t('actions.cancel')} onClick={() => setIsOpen(false)}
                                className='capitalize bg-gray-100 rounded  px-4 py-2  mx-2 border-1 border-gray-500  cursor-pointer hover:bg-gray-300 shadow'
                            />
                            <input
                                className={`capitalize text-white rounded px-4 py-2 border-1 shadow-md ${isValid ? 'bg-blue-500 border-blue-500 cursor-pointer hover:bg-blue-600' : 'bg-blue-300 border-blue-300 cursor-not-allowed opacity-60'}`}
                                type="submit" value={t('actions.create')} disabled={!isValid} />
                        </div>

                    </form>
                </SectionWrapper>








            </ModalWrapper>

        </>


    );

}

CreateAnnouncement.propTypes = {
  onCreate: PropTypes.func,
  disabled: PropTypes.bool,
};

export default CreateAnnouncement;

